<template lang="pug">
.sidebar-page
    .sidebar-layout
        Sidebar(@update:active="active = $event")
        Home(v-if="active === 'Home'")
        Profile(v-else-if="active === 'Profile'")
        Calendar(v-else-if="active === 'Calendar'")
        Settings(v-else-if="active === 'Settings'")
        TentCheck(v-else-if="active === 'Tent Check'")
        TextForm(v-else-if="active === 'Text'")
        Users(v-else-if="active === 'Users'")
        Rosters(v-else-if="active === 'Rosters'")
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";

// Main
import Home from "@/views/Home.vue";
import Profile from "@/views/Profile.vue";
import Calendar from "../views/Calendar.vue";
import Settings from "../views/Settings.vue";

// Tenting
import TentCheck from "../views/TentCheck.vue";
import TextForm from "../views/TextForm.vue";

// Admin
import Users from "../views/Users.vue";
import Rosters from "../views/Rosters.vue";

export default {
  name: "Dashboard",

  title: "LM Dashboard",

  components: {
    Sidebar,

    // Main
    Home,
    Profile,
    Calendar,
    Settings,

    // Tenting
    TentCheck,
    TextForm,

    // Admin
    Users,
    Rosters
  },

  data() {
    return {
      active: "Home"
    };
  }
};
</script>
